import { withChildren } from '@builder.io/react';
import { HeroOverlappedImageProps as Props } from './types';
import Image from 'next/image';
import style from './HeroOverlappedImage.module.scss';
export function HeroOverlappedImage({
  firstTopHeader,
  firstTopSubHeader,
  secondTopHeader,
  secondTopSubHeader,
  backgroundColor,
  titleColor,
  mainHeaderItems,
  backgroundImage,
  separationLineColor,
  marginBottomMobile,
  marginBottomDesktop,
  children
}: Props) {
  return <div className={style.heroWrapper} style={{
    backgroundColor,
    '--margin-bottom-mobile': marginBottomMobile,
    '--margin-bottom-desktop': marginBottomDesktop
  } as React.CSSProperties} data-sentry-component="HeroOverlappedImage" data-sentry-source-file="HeroOverlappedImage.tsx">
			<div className={style.topSectionWrapper}>
				<div className={style.topLeftTextWrapper}>
					<div className={style.textSeparator} style={{
          borderBottom: `0.5px solid ${separationLineColor}`
        }}>
						<span className={style.topLeftTextTitle}>{firstTopHeader}</span>
						<span className={style.topLeftTextSubTitle}>{firstTopSubHeader}</span>
					</div>

					<div className={style.textSeparator}>
						<span className={style.topLeftTextTitle}>{secondTopHeader}</span>
						<span className={style.topLeftTextSubTitle}>{secondTopSubHeader}</span>
					</div>
				</div>

				{backgroundImage && <div className={style.heroImageWrapper}>
						<Image src={backgroundImage} alt="Hero image" width={700} height={700} sizes="(max-width: 1023px) 63vw, 69vw" className={style.heroImage} priority />
					</div>}
			</div>

			<div className={style.heroHeaderTextWrapper} style={{
      color: titleColor
    }}>
				{mainHeaderItems && mainHeaderItems.map((item, i) => <span className={style.line} style={{
        '--line-font-size': `clamp(2.188px, ${item.fontSize}cqi, 18.5rem)`
      } as React.CSSProperties} key={`${item.text}-${i}`}>
							{item.text}
						</span>)}
			</div>
			{children && children.length > 0 && <div className={style.buttons}>{children}</div>}
		</div>;
}
export default withChildren(HeroOverlappedImage);